var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-easy-lightbox',{attrs:{"scrollDisabled":"","escDisabled":"","moveDisabled":"","visible":_vm.visible,"imgs":_vm.img},on:{"hide":_vm.handleHide}})
}
var staticRenderFns = []

export { render, staticRenderFns }